export default __webpack_public_path__ + "static/media/production.e3e2420f.svg";